const welcomeCampaign: { [key: string]: { active: boolean, code: string, discount: number, slug: string, title: string, price: number } } = {
    'au': {
        'active': false,
        'title': 'Welcome50',
        'code': 'WELCOME50',
        'discount': 50,
        'slug': 'welcome50',
        'price': 50
    },
    'nz': {
        'active': false,
        'title': 'Welcome50',
        'code': 'WELCOME50',
        'discount': 50,
        'slug': 'welcome50',
        'price': 50
    },
    'ca': {
        'active': false,
        'title': 'Welcome50',
        'code': 'WELCOME50',
        'discount': 50,
        'slug': 'welcome50',
        'price': 50
    },
    'international': {
        'active': false,
        'title': 'Welcome50',
        'code': 'WELCOME50',
        'discount': 50,
        'slug': 'welcome50',
        'price': 30
    }
}

export const getWelcomeCampaing = (region: string) => {
    return welcomeCampaign[region];
}